interface CrmOnlyBadgeProps {
  title?: string;
}

export const CrmOnlyBadge = ({
  title = 'Not linked to Blast yet.',
}: CrmOnlyBadgeProps) => (
  <span
    title={title}
    className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium border border-dashed border-gray-300 dark:border-gray-600 text-gray-500 dark:text-gray-400 bg-transparent"
  >
    CRM only
  </span>
);
